import type { ReactElement, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

type Props = {
  href: string;
  reload?: boolean;
  'data-cy'?: string;
  isDisabled?: boolean;
  children: ReactNode;
};

function Link({
  href,
  reload = false,
  'data-cy': dataCy = '',
  children,
  isDisabled = false,
}: Props): ReactElement {
  if (isDisabled) {
    return (
      <li>
        <span className="c-nav__link c-nav-account-sidebar__link is-disabled">
          {children}
        </span>
      </li>
    );
  }

  return (
    <li>
      {reload ? (
        <a
          className="c-nav-account-sidebar__link"
          data-cy={dataCy}
          href={href}
        >
          {children}
        </a>
      ) : (
        <NavLink
          className={({ isActive }) => ([
            'c-nav-account-sidebar__link',
            isActive ? 'is-active' : '',
          ].join(' '))}
          data-cy={dataCy}
          to={href}
        >
          {children}
        </NavLink>
      )}
    </li>
  );
}

export default Link;
